module.exports = __webpack_public_path__ + "static/media/c_img.027d4647.jpg";